// extracted by mini-css-extract-plugin
export var subtitle = "_82-2";
export var title = "_82-0";
export var titleNoWrap = "_82-1";